
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { Shield, Globe, Clock, BarChart4 } from 'lucide-react';

const RadexAbout = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto mb-16 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            {t('radex.about.title') || "About Radex Markets"}
          </h2>
          <p className="text-lg text-gray-300">
            {t('radex.about.subtitle') || "A regulated broker committed to security, transparency, and cutting-edge trading technology"}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          <div className="bg-gray-800/50 border border-gray-700 rounded-lg p-8">
            <div className="mb-6">
              <Globe className="h-10 w-10 text-purple-500 mb-4" />
              <h3 className="text-xl font-bold text-white mb-2">
                {t('radex.about.establishmentTitle') || "Established Presence"}
              </h3>
              <p className="text-gray-300">
                {t('radex.about.establishmentText') || "RADEX MARKETS was established in 2019 and is headquartered in the Republic of Seychelles. Operating under the trading name of GO Markets International Ltd, a company incorporated in the Republic of Seychelles with registration number 8425985-1."}
              </p>
            </div>
            
            <div>
              <Shield className="h-10 w-10 text-purple-500 mb-4" />
              <h3 className="text-xl font-bold text-white mb-2">
                {t('radex.about.regulationTitle') || "Licensed & Regulated"}
              </h3>
              <p className="text-gray-300">
                {t('radex.about.regulationText') || "The firm is licensed and regulated by the Seychelles Financial Services Authority (FSA) under Securities Dealer License Number SD043, ensuring a secure and compliant trading environment."}
              </p>
            </div>
          </div>
          
          <div className="bg-gray-800/50 border border-gray-700 rounded-lg p-8">
            <div className="mb-6">
              <BarChart4 className="h-10 w-10 text-purple-500 mb-4" />
              <h3 className="text-xl font-bold text-white mb-2">
                {t('radex.about.technologyTitle') || "Advanced Technology"}
              </h3>
              <p className="text-gray-300">
                {t('radex.about.technologyText') || "Radex Markets offers cutting-edge technology and a competitive trading environment designed to meet the needs of modern traders, with reliable execution and professional tools."}
              </p>
            </div>
            
            <div>
              <Clock className="h-10 w-10 text-purple-500 mb-4" />
              <h3 className="text-xl font-bold text-white mb-2">
                {t('radex.about.transparencyTitle') || "Transparency & Trust"}
              </h3>
              <p className="text-gray-300">
                {t('radex.about.transparencyText') || "Transparency is a core value at Radex, demonstrated through clear, honest, and multilingual communication. Renowned for its integrity, Radex Markets stands out as a secure and trustworthy platform for traders seeking reliability."}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RadexAbout;
